import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  border: 1px solid #d9d9d9;
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  margin-top: 24px;
`

export const Content = styled.div<{ open: boolean }>`
  overflow: hidden;
  transition: 200ms;
  ${(props) =>
    !props.open &&
    css`
      height: 0;
    `}
`
